import React from 'react'

const OriginWarning = () => {
  // This component is now empty because we've removed the origin warning logic.
  return <></>
}

export default OriginWarning
